import CallCenterIcon from '@/components/Icons/CallCenter.vue';

import contact_details_routes from './contactDetails/contact-details.routes';
import extensions_routes from './extensions/extensions.routes';
import webphone_routes from './webphone/webphone.routes';


const call_center_nested_routes = [extensions_routes, webphone_routes, contact_details_routes];

const call_center_routes = {
  path: '/call-center',
  name: 'call-center',
  meta: {
    header: { title: 'call_center.call_center', icon: CallCenterIcon },
    sidebar: [
      {
        title: 'call_center.live_panel',
        route: '/call-center/extensions',
        icon: 'bvi-headphones',
        permissions: 'read-live-panel',
      },
      {
        title: 'call_center.webphone_title',
        route: '/call-center/webphone',
        icon: 'bvi-dial-pad-solid',
        permissions: 'read-webphone',
      },
    ],
  },
  children: call_center_nested_routes,
};

export default call_center_routes;
